import * as Yup from 'yup'
import { DefaultStrings, GetStringFunction } from '.'

export const getAddressStringSchema = (
  required: boolean,
  getString: GetStringFunction<DefaultStrings>,
  errorKey: keyof DefaultStrings
) => {
  if (required) {
    return Yup.string().required(getString(errorKey))
  } else {
    return Yup.string()
  }
}
